(function () {
  const MESSAGE_ID = "gift-flower-cart-message";
  const MESSAGE_TEXT =
    "You can’t checkout with only Gift products. Please add at least one Flower item to proceed.";

  function getCartDrawerRoot() {
    // Covers Dawn + many themes
    return (
      document.querySelector("cart-drawer") ||
      document.querySelector("#CartDrawer") ||
      document.querySelector(".cart-drawer") ||
      document.querySelector("[data-cart-drawer]")
    );
  }

  function drawerIsVisible(drawer) {
    if (!drawer) return false;

    // Dawn toggles an "active"/"open" state; also visibility can be inferred
    const isOpenByAttr =
      drawer.hasAttribute("open") ||
      drawer.getAttribute("aria-hidden") === "false" ||
      drawer.classList.contains("active") ||
      drawer.classList.contains("is-open") ||
      drawer.classList.contains("open");

    const rect = drawer.getBoundingClientRect();
    const isVisibleByBox = rect.width > 0 && rect.height > 0;

    return isOpenByAttr || isVisibleByBox;
  }

  function findCheckoutButtons(scope) {
    const root = scope || document;

    // Buttons/links used in cart page + cart drawer
    const selectors = [
      'button[name="checkout"]',
      'button[type="submit"][name="checkout"]',
      'button[data-testid="Checkout-button"]',
      'button.cart__checkout-button',
      'a[href^="/checkout"]',
      'form[action^="/checkout"] button[type="submit"]'
    ];

    return selectors
      .map((s) => Array.from(root.querySelectorAll(s)))
      .flat()
      .filter(Boolean);
  }

  function disableCheckout(scope, disabled) {
    const buttons = findCheckoutButtons(scope);

    buttons.forEach((btn) => {
      const tag = (btn.tagName || "").toLowerCase();

      if (tag === "a") {
        btn.setAttribute("aria-disabled", disabled ? "true" : "false");
        btn.style.pointerEvents = disabled ? "none" : "";
        btn.style.opacity = disabled ? "0.5" : "";
      } else {
        btn.disabled = !!disabled;
        btn.style.opacity = disabled ? "0.5" : "";
      }
    });

    return buttons.length > 0;
  }

  function ensureMessage(container) {
    if (!container) return;

    let el = container.querySelector(`#${MESSAGE_ID}`);
    if (!el) {
      el = document.createElement("div");
      el.id = MESSAGE_ID;
      el.style.cssText =
        "margin:12px 0;padding:12px 14px;border:1px solid #e11d48;border-radius:10px;background:#fff1f2;color:#9f1239;font-size:14px;line-height:1.35;";
      el.innerText = MESSAGE_TEXT;

      // Put message near top of container
      container.prepend(el);
    }
  }

  function removeMessage(container) {
    if (!container) return;
    const el = container.querySelector(`#${MESSAGE_ID}`);
    if (el) el.remove();
  }

  function readMarkers(scope) {
    const markers = scope.querySelectorAll(".js-lineitem-rule");
    let hasGift = false;
    let hasFlower = false;

    markers.forEach((m) => {
      const isGift = (m.getAttribute("data-is-gift") || "") === "true";
      const isFlower = (m.getAttribute("data-is-flower") || "") === "true";
      if (isGift) hasGift = true;
      if (isFlower) hasFlower = true;
    });

    return { hasGift, hasFlower, markerCount: markers.length };
  }

  function evaluateForCartPage() {
    const isCartPage = (window.location.pathname || "").startsWith("/cart");
    if (!isCartPage) return;

    const main =
      document.querySelector("main") ||
      document.querySelector(".width--content") ||
      document.body;

    const { hasGift, hasFlower, markerCount } = readMarkers(document);
    if (markerCount === 0) {
      removeMessage(main);
      disableCheckout(document, false);
      return;
    }

    if (hasGift && !hasFlower) {
      ensureMessage(main);
      disableCheckout(document, true);
    } else {
      removeMessage(main);
      disableCheckout(document, false);
    }
  }

  function evaluateForDrawer() {
    const drawer = getCartDrawerRoot();
    if (!drawer || !drawerIsVisible(drawer)) return;

    // Try to find a good inner container to show message inside drawer
    const drawerContainer =
      drawer.querySelector(".drawer__inner") ||
      drawer.querySelector(".cart-drawer__inner") ||
      drawer.querySelector(".global-drawer__body") ||
      drawer;

    const { hasGift, hasFlower, markerCount } = readMarkers(drawer);
    if (markerCount === 0) {
      removeMessage(drawerContainer);
      disableCheckout(drawer, false);
      return;
    }

    if (hasGift && !hasFlower) {
      ensureMessage(drawerContainer);
      disableCheckout(drawer, true);
    } else {
      removeMessage(drawerContainer);
      disableCheckout(drawer, false);
    }
  }

  function evaluateAll() {
    evaluateForCartPage();
    evaluateForDrawer();
  }

  // Run once
  evaluateAll();

  // Re-run after ajax updates (themes often dispatch events)
  document.addEventListener("cart:updated", evaluateAll);
  document.addEventListener("cart:refresh", evaluateAll);

  // Dawn updates sections via fetch; watch DOM changes as fallback
  if ("MutationObserver" in window) {
    const obs = new MutationObserver(() => {
      clearTimeout(window.__giftFlowerCartRuleT);
      window.__giftFlowerCartRuleT = setTimeout(evaluateAll, 150);
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }

  // Also re-check when user clicks cart icon (drawer opens)
  document.addEventListener("click", function (e) {
    const t = e.target;
    if (!t) return;
    // cart icon/trigger varies; this is safe and cheap
    setTimeout(evaluateAll, 250);
  });
})();
